module.exports = __webpack_public_path__ + "img/Danee.3b43b568.jpg";